import { useEffect, useState } from 'react';
import { isIPad13, isMobile } from 'mobile-device-detect';

const LANDSCAPE = '(orientation: landscape)';

export const useDeviceOrientation = () => {
    const [isLandscape, setIsLandscape] = useState(
        () => window.matchMedia(LANDSCAPE).matches && isMobile && !isIPad13,
    );

    useEffect(() => {
        const handler = (e: { matches: boolean }) => {
            const landscape = e.matches;

            setIsLandscape(landscape);
        };

        window.matchMedia(LANDSCAPE).addEventListener('change', handler);

        return () => {
            window.matchMedia(LANDSCAPE).removeEventListener('change', handler);
        };
    }, []);

    return { isLandscape };
};
